var Font = require('./font');

function FontMetrics() {
    this.data = {};
}

FontMetrics.prototype.getMetrics = function(family, size) {
    if (this.data[family + "-" + size] === undefined) {
        this.data[family + "-" + size] = new Font(family, size);
    }
    return this.data[family + "-" + size];
};

module.exports = FontMetrics;



//////////////////
// WEBPACK FOOTER
// ./~/aframe-htmltexture-component/vendor/html2canvas/fontmetrics.js
// module id = 247
// module chunks = 0